import { put, takeEvery } from "@redux-saga/core/effects";
import {
	handleNotificationAlertCatch,
	handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import AxiosCustom from "../../../common/components/apiConfig";

export const actionTypes = {
	selectSettlementStatistics: "[selectSettlementStatistics] Action",
	selectSettlementStatisticsLoad: "[selectSettlementStatisticsLoad] Action",
	selectSettlementStatisticsAsync: "[selectSettlementStatisticsAsync] Action",
};

const initialState = {
	data: [],
	loading: false,
};

export const select_settlement_statistics_reducer = (
	state = initialState,
	{ type, payload },
) => {
	switch (type) {
		case actionTypes.selectSettlementStatistics:
			return {
				...state,
				data: payload?.data?.results ? payload?.data?.results : [],
			};

		case actionTypes.selectSettlementStatisticsLoad:
			return {
				...state,
				loading: payload,
			};
		default:
			return state;
	}
};

function* handleWorker({ payload }) {
	yield put({
		type: actionTypes.selectSettlementStatisticsLoad,
		payload: payload,
	});
	let config = {
		url: "select_request",
	};

	let data = {
		table: "credit",
		method_type: "select_settlement_statistics",
		data: payload?.data ? payload?.data : {},
		sort_by: {},
		size: "50",
		from: "0",
	};

	try {
		let res = yield AxiosCustom(config, data);
		let isOk = handleNotificationAlertTrySelect(res);
		yield put({
			type: actionTypes.selectSettlementStatistics,
			payload: res.data.response,
		});
	} catch {
		handleNotificationAlertCatch();
		// yield put({ type: actionTypes.creaditSelectLoad, payload: false });
	} finally {
		yield put({
			type: actionTypes.selectSettlementStatisticsLoad,
			payload: false,
		});
	}
}

export function* selectSettlementStatistics() {
	yield takeEvery(actionTypes.selectSettlementStatisticsAsync, handleWorker);
}
